import React, { useRef } from 'react';
import Select from 'react-select';
import ltagList from "../../../../../assets/static/LocationTags.json";
import rtagList from "../../../../../assets/static/RemedyTags.json";
function TagSelector({isRemedy,tags, setTags}) {
  const options = useRef((isRemedy ? rtagList : ltagList).map(tag=>({value:tag,label:tag})))
  
  return (
    <Select 
      closeMenuOnSelect={false}
      placeholder="Filter Tags"
      value={tags}
      onChange={newValue=>setTags(newValue)}
      isMulti
      options={options.current}
    />
  );
}

TagSelector.defaultProps = {
  initTags : [],
  setTags:()=>{}
}

export default TagSelector;